/*
# -----------------------------------------------------------------------------
#	Project: HSE Genius®
#	Client ID: 834215
#	Registration Code: IT-2025-ZR319-MQ744
#	Author: KaimakiWeb
#	Website: https://kaimakiweb.com
#	Copyright (c) 2024-2026 Kaimaki Web. All rights reserved.
#
#	This software and its source code are the property of KaimakiWeb.
#	Unauthorized copying, modification, distribution, or use of this software,
#	via any medium, is strictly prohibited unless prior written permission
#	is obtained from KaimakiWeb.
# -----------------------------------------------------------------------------
*/

import ThemeEnum from "../../../../configs/theme/enums/theme.enum";
import {IconButton, Tooltip, useTheme} from "@mui/material";
import {useContext} from "react";
import {ColorModeContext} from "../../../../configs/theme/context/color-mode.context";
import {useTranslation} from "react-i18next";
import {WbSunny, DarkMode} from "@mui/icons-material";

const ThemeSwitcher = ({ tooltipPlacement = undefined, tooltipSlotProps = undefined }) => {
    const theme = useTheme();
    const colorMode = useContext(ColorModeContext);
    const {t} = useTranslation();

    const toggleThemeMode = () => {
        colorMode.toggleColorMode();
    };

    const isLightMode = theme.palette.mode === ThemeEnum.LIGHT_MODE;

    const iconSx = { fontSize: 20, color: isLightMode ? theme.palette.text.primary : '#ffffff' };

    const placement = tooltipPlacement || 'bottom';
    const tooltipTitle = isLightMode ? t('theme.set-dark') : t('theme.set-light');

    return (
        <Tooltip title={tooltipTitle} placement={placement} slotProps={tooltipSlotProps}>
            <IconButton
                onClick={toggleThemeMode}
                color="inherit"
                size="small"
                sx={{
                    padding: '4px',
                    '&:hover': {
                        backgroundColor: 'transparent',
                    },
                }}
            >
                {isLightMode ? (
                    <WbSunny sx={iconSx} />
                ) : (
                    <DarkMode sx={iconSx} />
                )}
            </IconButton>
        </Tooltip>
    );
};

export default ThemeSwitcher;